import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import {actions} from "react-redux-form";
import {validateRegister, validateEmail, registerUser, registerEmail} from "./actions/register";
//import _ from "lodash";
import GobLogo from './assets/images/gobmxlogo.svg';
import INMLogo from './assets/images/logo_inm.svg';
import RegisterBox from './elements/register/register';
//import Loading from "./elements/loading";

class RegisterLayout extends Component {
	render () {
		const {register} = this.props;
		return (
			<section className="hero is-fullheight is-black login-layout">
				<div className="hero-head">
					<header className="nav" style={{backgroundColor:'#393c3e'}}>
						<div className="container">
							<div className="nav-left">
								<a className="nav-item">
									<img src={GobLogo} alt="Logo"/>
								</a>
							</div>
						</div>
					</header>
				</div>

				<div className="hero-body">
					<div className="container">
						{register.style !== 'is-10'?
						<div className="columns is-centered is-gapless" >
							<div className="column is-one-third">
								<div className="columns is-gapless">
									<div className="column">
										<img src={INMLogo} alt="Instituto Nacional de la Mujer" className="logo-inm" />
									</div>
								</div>
							</div>
						</div>:''}

						<div className="columns is-centered is-gapless">
							<div className={`column ${register.style}`}>
								<RegisterBox {...this.props}/>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}

	componentWillMount(){
		const {state} = this.props.register;
		if(state === 'close'){
			this.props.validateRegister();
		}
	}

};

const mapStateToProps = (state) => {
	const { register } = state;
	return {register};
}

const mapDispatchToProps = dispatch => {
	return {
		validateRegister: () => {
			dispatch(validateRegister())
		},
		validateEmail: (email) => {
			dispatch(validateEmail(email))
		},
		registerUser: (values) => {
			dispatch(registerUser(values))
		},
		registerEmail: (values) => {
			dispatch(registerEmail(values))
		},
		change: (model,value) => {
			dispatch(actions.change(model,value))
		},
		reset: () => {
			dispatch(actions.reset('register'))
			dispatch(validateRegister())
		}
	}
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterLayout));


// WEBPACK FOOTER //
// ./src/registerapp.js